import React from 'react';
import PropTypes from 'prop-types';
import {Step1Icon, Step2Icon, Step3Icon2, Step4Icon} from "../../theme/AthenaIcons";

class FormStepperIcons extends React.Component {
  static propTypes = {
    active: PropTypes.bool.isRequired,
    completed: PropTypes.bool.isRequired,
    icon: PropTypes.node.isRequired,
  };

  render() {
    const { active, completed, icon } = this.props;
    let stroke = null;

    if(!active && completed){
      stroke = '#333';
    }else if(!active && !completed){
      stroke = '#b1b1b1';
    }

    const icons = {
      1: <Step1Icon stroke={stroke}/>,
      2: <Step2Icon stroke={stroke}/>,
      3: <Step3Icon2 stroke={stroke}/>,
      4: <Step4Icon stroke={stroke}/>,
    };
    return (
        <div>
          {icons[String(icon)]}
        </div>
      )
  }
}

export default FormStepperIcons;
